
























































import { Component, Prop, Vue } from 'vue-property-decorator';
import Tooltip, {
  TooltipColor,
} from '@/shared/components/Tooltip.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
export { IconEnum };

export enum CheckIconColor {
  Primary = 'check-icon--primary',
  NoAction = 'no-action',
  Secondary = 'check-icon--secondary',
  Gold = 'check-icon--gold',
  GoldDark = 'check-icon--gold-dark',
  BlueDark = 'check-icon--blue-dark',
  Pink = 'check-icon--pink'
}

@Component({
  components: {
    Tooltip,
    Icon,
  },
})
export default class CheckIcon extends Vue {
  @Prop() private iconClass!: string;
  @Prop() private checkIconClass!: CheckIconColor;
  @Prop({ default: '' }) private tooltipTextActive!: string;
  @Prop({ default: '' }) private tooltipTextInactive!: string;
  @Prop() private tooltipClass!: string;
  @Prop({ default: false }) private actived!: boolean;
  @Prop({ default: false }) private disabled!: boolean;
  @Prop({ default: true }) private editable!: boolean;
  @Prop({ default: undefined }) private secondLine!: any;
  @Prop({ default: undefined }) private titleContent!: any;
  @Prop({ default: false }) private inOddContainer!: boolean;

  get disableTooltip() {
    const hasTooltipText =
      this.tooltipTextActive !== '' || this.tooltipTextInactive !== '';
    return this.disabled || !hasTooltipText;
  }

  get tooltipText() {
    return this.actived ? this.tooltipTextActive : this.tooltipTextInactive;
  }

  get showTitle() {
    return this.titleContent !== undefined;
  }

  get showSecondLine() {
    return this.secondLine !== undefined;
  }

  get formatTitle() {
    const result = { convocationOut: '', location: '', dates: '' };
    if (this.secondLine !== undefined) {
      if (this.titleContent.convocationOut) {
        result.convocationOut = this.titleContent.convocationOut;
      }
      if (this.titleContent.location) {
        result.location = this.titleContent.location;
      }
      if (this.titleContent.dates) {
        result.dates = this.titleContent.dates;
      }
    }
    return result;
  }

  get formatSecondLine() {
    const result = { justified: '', day: '', month: '', user: '' };
    if (this.secondLine !== undefined) {
      if (this.secondLine.justified) {
        result.justified = this.secondLine.justified;
      }
      result.day = this.secondLine.day;
      result.month = this.secondLine.month;
      result.user = this.secondLine.user;
    }
    return result;
  }

  private handleMouseEnter() {
    this.$emit('mouseenter', true);
  }

  private get noAction() {
    return this.checkIconClass === CheckIconColor.NoAction;
  }

  private handleClick($event: any) {
    if (this.editable && !this.noAction) {
      this.$emit('input', !this.actived);
    }
    this.$emit('check-icon-click', $event);
  }
}
